import React from 'react';
import { connect } from 'react-redux';
import classes from './CalendarSmall.scss';
import moment from 'moment';

import CalendarBoxSmall from './CalendarBoxSmall/CalendarBoxSmall';
import CalendarBoxLarge from './CalendarBoxLarge/CalendarBoxLarge';

const calendarSmall = (props) => {

    const activeDate = moment(props.activeDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
    const lowestFare = props.lowestFare.lf;

    let dayData = props.lowestFare.day;
    let calendarBoxSmall = null;
    let calendarBoxLarge = null;
    if (dayData) {
        calendarBoxSmall = Object.keys(dayData).map((key, index) => {
            return <CalendarBoxSmall key={index} date={key} lf={dayData[key].lf} active={activeDate === key ? true : false} lfActive={dayData[key].lf === lowestFare ? true : false} />;
        })    
        calendarBoxLarge = <CalendarBoxLarge date={props.lowestFare.ld}/>;
    }
    
    return (
        <div className={`${classes.Wrapper} u-flex`}>
            <div className={`${classes.Left} u-flex`}>
                {calendarBoxSmall}
            </div>
            <div className={`${classes.Right} u-phoneHide`}>
                {/* {calendarBoxLarge} */}
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        lowestFare: state.lowestFare.lowestFare,
        activeDate: state.flights.departDate
    }
}

export default connect(mapStateToProps)(calendarSmall);


// WEBPACK FOOTER //
// ./src/components/CalendarSmall/CalendarSmall.js